// extracted by mini-css-extract-plugin
export var container = "_d8-0";
export var icon = "_d8-1";
export var text = "_d8-2";